import { useState } from "react";
import { useNavigate } from "react-router-dom";

import Button from "@mui/material/Button";
import { Box, Stack, Checkbox, Typography, lighten } from "@mui/material";
import { Add } from "@mui/icons-material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { Agenda } from "./Agenda";

import ButtonGoBack from "../../components/Buttons/outlinedGoback";

const styles = {
  title: {
    fontWeight: "600",
    fontSize: "26px",
    lineHeight: "35px",
    color: "#063F5E",
    fontFamily: "Nunito, sans-serif ",
  },
  subtitle: {
    fontWeight: "300",
    fontSize: "18px",
    lineHeight: "25px",
    marginBottom: "5px",
    marginTop: "10px",
    color: "#1E729F",
  },
};

export default function Agendamentos() {
  const navigate = useNavigate();
  const [consultasSelecionadas, setConsultasSelecionadas] = useState([
    1, 2, 3, 4, 5, 6,
  ]);
  const [dataSelecionada, setDataSelecionada] = useState(new Date());

  const handleSelecionarConsulta = (e) => {
    let { value, checked } = e.target;

    value = parseInt(value);

    if (consultasSelecionadas === undefined) {
      consultasSelecionadas = [];
    }

    if (checked) {
      setConsultasSelecionadas([...consultasSelecionadas, value]);
    } else {
      setConsultasSelecionadas(
        consultasSelecionadas.filter((e) => e !== value)
      );
    }
  };

  const opcaoSelecionada = (valor) => {
    return consultasSelecionadas.includes(valor);
  };

  return (
    <Box
      width={"100%"}
      minHeight={"90vh"}
      bgcolor={"red"}
      sx={{
        paddingBottom: "100px",
      }}
    >
      <ButtonGoBack />

      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
        }}
      >
        <Box style={styles.title}>Agendamentos</Box>

        <Button
          variant="contained"
          color="primary"
          endIcon={<Add />}
          onClick={() => {
            navigate("/agendamentos/novo-agendamento");
          }}
          sx={{ textTransform: "none" }}
        >
          Novo Agendamento
        </Button>
      </Box>

      <Stack flexDirection={{ xs: "column-reverse", md: "row" }}>
        <Box width={"100%"} height={"100%"}>
          <Agenda
            consultasSelecionadas={consultasSelecionadas}
            dataSelecionada={dataSelecionada}
          />
        </Box>
        <Stack
          width={{ xs: "100%", md: "320px" }}
          flexDirection={{ xs: "column", sm: "row", md: "column" }}
          justifyContent={{ xs: "center", sm: "space-between", md: "normal" }}
          flexWrap={{ xs: "initial", sm: "wrap" }}
        >
          <Stack
            width={"320px"}
            sx={{
              margin: { xs: "0 auto", md: "0" },
            }}
          >
            <LocalizationProvider
              adapterLocale="pt-BR"
              dateAdapter={AdapterDayjs}
            >
              <DateCalendar
                onChange={(date) => setDataSelecionada(date.$d)}
                sx={{
                  "& .MuiPickersDay-root": {
                    color: "#1E729F",
                    "&:hover": {
                      backgroundColor: lighten("#1E729F", 0.7),
                    },
                  },
                  "& .Mui-selected": {
                    backgroundColor: "#1E729F ",
                    color: "#ffff ",
                  },
                }}
              />
            </LocalizationProvider>
            <Button
              variant="outlined"
              color="primary"
              sx={{ width: 50, textTransform: "none", alignSelf: "end", mr: 2 }}
              onClick={() => setDataSelecionada(new Date())}
            >
              Hoje
            </Button>
          </Stack>

          <Stack
            sx={{
              alignItems: "start",
              p: 2,
              maxWidth: "280px",
              margin: { xs: "0 auto", md: "0" },
            }}
          >
            <Typography sx={{ ml: 1 }}>Legenda:</Typography>
            <Box>
              <Checkbox
                style={{ color: "#1E729F" }}
                checked={opcaoSelecionada(1)}
                value={1}
                onClick={handleSelecionarConsulta}
              />{" "}
              Consulta multidisciplinar
            </Box>
            <Box>
              <Checkbox
                style={{ color: "#A254DF" }}
                checked={opcaoSelecionada(4)}
                value={4}
                onClick={handleSelecionarConsulta}
              />{" "}
              Consulta neurologia
            </Box>
            <Box>
              <Checkbox
                style={{ color: "#65C94D" }}
                checked={opcaoSelecionada(5)}
                value={5}
                onClick={handleSelecionarConsulta}
              />{" "}
              Consulta nutrição
            </Box>
            <Box>
              <Checkbox
                style={{ color: "#FE9647" }}
                checked={opcaoSelecionada(2)}
                value={2}
                onClick={handleSelecionarConsulta}
              />{" "}
              Consulta fisioterapia
            </Box>
            <Box>
              <Checkbox
                style={{ color: "#7AABC5" }}
                checked={opcaoSelecionada(6)}
                value={6}
                onClick={handleSelecionarConsulta}
              />{" "}
              Consulta psicologia
            </Box>
            <Box>
              <Checkbox
                style={{ color: "#D85050" }}
                checked={opcaoSelecionada(3)}
                value={3}
                onClick={handleSelecionarConsulta}
              />{" "}
              Consulta fonoaudiologia
            </Box>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
}
